/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeletedStatusDto } from '../models/DeletedStatusDto';
import type { RegionCreateDto } from '../models/RegionCreateDto';
import type { RegionDto } from '../models/RegionDto';
import type { RegionUpdateDto } from '../models/RegionUpdateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminRegionsService {
  /**
   * List all editorial regions.
   * @returns RegionDto
   * @throws ApiError
   */
  public static adminRegionsControllerListRegions(): CancelablePromise<Array<RegionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/regions',
    });
  }
  /**
   * Create editorial region.
   * @param requestBody
   * @returns RegionDto
   * @throws ApiError
   */
  public static adminRegionsControllerCreateRegion(
    requestBody: RegionCreateDto,
  ): CancelablePromise<RegionDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/regions',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update editorial region.
   * @param id
   * @param requestBody
   * @returns RegionDto
   * @throws ApiError
   */
  public static adminRegionsControllerUpdateRegion(
    id: string,
    requestBody: RegionUpdateDto,
  ): CancelablePromise<RegionDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/regions/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete editorial region.
   * @param id
   * @returns DeletedStatusDto Region deleted.
   * @throws ApiError
   */
  public static adminRegionsControllerDeleteRegion(
    id: string,
  ): CancelablePromise<DeletedStatusDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/regions/{id}',
      path: {
        id: id,
      },
    });
  }
}
